/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Deployment, Deployment$inboundSchema } from "./deployment.js";
import { Meta, Meta$inboundSchema } from "./meta.js";

export type V1DeploymentsGetDeploymentResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  data: Deployment;
};

/** @internal */
export const V1DeploymentsGetDeploymentResponseBody$inboundSchema: z.ZodType<
  V1DeploymentsGetDeploymentResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: Deployment$inboundSchema,
});

export function v1DeploymentsGetDeploymentResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1DeploymentsGetDeploymentResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      V1DeploymentsGetDeploymentResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1DeploymentsGetDeploymentResponseBody' from JSON`,
  );
}
